exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".profile--row--nJLaEa1C {\r\n  padding: 0 16px 0 8px;\r\n}\r\n\r\n.profile--col--1LgDBqZi{\r\n display: flex;\r\n padding: 0 4px 0 4px; \r\n}\r\n\r\n.profile--profileGrid--1HJKQbjg {\r\n  width: 100%;\r\n  margin-bottom: 8px;\r\n}", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/views/profile/profile.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;CACvB;;AAED;CACC,cAAc;CACd,qBAAqB;CACrB;;AAED;EACE,YAAY;EACZ,mBAAmB;CACpB","file":"profile.css","sourcesContent":[".row {\r\n  padding: 0 16px 0 8px;\r\n}\r\n\r\n.col{\r\n display: flex;\r\n padding: 0 4px 0 4px; \r\n}\r\n\r\n.profileGrid {\r\n  width: 100%;\r\n  margin-bottom: 8px;\r\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"row": "profile--row--nJLaEa1C",
	"col": "profile--col--1LgDBqZi",
	"profileGrid": "profile--profileGrid--1HJKQbjg"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/views/profile/profile.css
// module id = 444
// module chunks = 0